import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { BackdropLoader } from '@livable/saas-react-components';
import { Button, Container, Paper } from '@mui/material';
import { BillsProgress } from 'src/components/allocations/AllocationProgress/BillsProgress';
import NoAllocations from 'src/components/allocations/AllocationProgress/NoAllocations';
import CurrentCycle from 'src/components/allocations/CurrentCycle';
import Separator from 'src/components/general/Separator';
import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import { useStore } from 'src/stores';
import { sortCycles } from 'src/utils/date';
import useStyles from './styles';
export default function AllocationsTab(_ref) {
  let propertyAddress = _ref.propertyAddress,
    propertyId = _ref.propertyId;
  const classes = useStyles();
  const navigate = useNavigate();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    allUtilities = _useState2[0],
    setAllUtilities = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  const _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    previous = _useState6[0],
    setPrevious = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showButton = _useState8[0],
    setShowButton = _useState8[1];
  const _useState9 = useState(''),
    _useState0 = _slicedToArray(_useState9, 2),
    theOldestCycleName = _useState0[0],
    setTheOldestCycleName = _useState0[1];
  useEffect(() => {
    setIsLoading(true);
    const getAllocationsHistory = async data => {
      const resp = await store.allocations.getAllocationsHistoryAsync.run(data);
      return resp;
    };
    const getCompanyProperties = async () => {
      const resp = await store.company.getCompanyPropertiesAsync.run();
      return resp;
    };
    const getCurrentCycle = async data => {
      const resp = await store.allocations.getCurrentCycleAsync.run(data);
      return resp;
    };
    let companyProperties;
    Promise.all([getCurrentCycle({
      companyId: localStorage.getItem(USER_SETTINGS_KEYS.company)
    }), getAllocationsHistory({
      companyId: localStorage.getItem(USER_SETTINGS_KEYS.company)
    }), getCompanyProperties().then(resp => {
      companyProperties = resp.response;
    })]).then(() => {
      var _sorted$at, _companyProperties$fi;
      const sorted = [...store.allocations.history.map(cycle => _objectSpread(_objectSpread({}, cycle), {}, {
        ym: "".concat(cycle.year).concat(cycle.month.toString().padStart(2, '0')) * 1
      })).sort(sortCycles)];
      setTheOldestCycleName((_sorted$at = sorted.at(-1)) === null || _sorted$at === void 0 ? void 0 : _sorted$at.name);
      const allCycles = sorted.filter(c => c.id !== store.allocations.currentCycle.id);
      setShowButton(allCycles.length > 6);
      setPrevious(allCycles.slice(0, 6));
      const utilities = (_companyProperties$fi = companyProperties.find(property => property.propertyId === propertyId)) === null || _companyProperties$fi === void 0 ? void 0 : _companyProperties$fi.utilities;
      setAllUtilities(utilities);
      setIsLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(Container, {
    className: classes.pageContainer
  }, !isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CurrentCycle, {
    daysTillStatementDate: store.allocations.currentCycle.daysTillStatementDate,
    name: store.allocations.currentCycle.name,
    statementDate: moment(store.allocations.currentCycle.statementDate).format('L')
  }), /*#__PURE__*/React.createElement(BillsProgress, {
    cycle: store.allocations.currentCycle,
    hideStatement: true,
    key: store.allocations.currentCycle.id,
    selectedBuilding: propertyId,
    title: propertyAddress,
    utilities: allUtilities
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Separator, {
    text: t('allocations.allocation_history_preview', {
      monthsCounter: 6
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, previous.map(cycle => /*#__PURE__*/React.createElement(BillsProgress, {
    cycle: cycle,
    fromHistory: true,
    key: cycle.id,
    selectedBuilding: propertyId,
    title: cycle.name,
    utilities: allUtilities
  })), previous.length < 6 && /*#__PURE__*/React.createElement(NoAllocations, {
    name: theOldestCycleName
  })), showButton && /*#__PURE__*/React.createElement(Button, {
    className: classes.lgSection,
    onClick: () => navigate("/allocations/allocations_history?propertyId=".concat(propertyId)),
    variant: "huge",
    'custom-attribute': '821-residents-page-allocations-tab'
  }, "View full allocation history")) : /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: true
  }), /*#__PURE__*/React.createElement(NoAllocations, null)));
}